"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
          <div className="h-9 w-16 bg-muted-light/20 animate-pulse rounded-md" />
          <div className="h-9 w-16 bg-muted-light/20 animate-pulse rounded-md" />
          <div className="h-9 w-16 bg-muted-light/20 animate-pulse rounded-md" />
        </div>;
  }
  return <>
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-primary hover:text-foreground-primary transition-colors duration-[var(--duration-medium)]" aria-label="Toggle menu">
          {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
        </button>

        <NavigationMenu viewport={false} className="hidden md:flex">
          <NavigationMenuList>
            {menuItems.map(item => <NavigationMenuItem key={item.id} data-index={item.id}>
                <NavigationMenuLink asChild>
                  <Link to={item.href || "#"} className="relative inline-flex items-center justify-center h-9 px-4 py-2 text-base font-medium text-primary hover:!bg-transparent focus:!bg-transparent transition-all duration-[var(--duration-medium)] hover:scale-[1.02] hover:text-foreground-primary after:content-[''] after:absolute after:bottom-1 after:left-1/2 after:-translate-x-1/2 after:w-0 after:h-0.5 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] hover:after:w-[calc(100%-2rem)]">
                    {item.label}
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>

        {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-background border-t border-border shadow-medium">
            <nav className="flex flex-col p-4">
              {menuItems.map(item => <Link key={item.id} data-index={item.id} to={item.href || "#"} className="py-3 px-4 text-lg font-medium text-primary hover:text-foreground-primary hover:bg-muted-dark-background rounded-md transition-all duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
                  {item.label}
                </Link>)}
            </nav>
          </div>}
      </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className="fixed top-0 left-0 right-0 z-50 w-full backdrop-blur-md border-b border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] h-auto md:h-24 !bg-[hsl(0,0%,100%)]">
        <div className="container mx-auto px-4 h-full flex items-center justify-between !bg-[hsl(0,0%,100%)]">
          <Link to="/" className="flex-shrink-0">
            <img src="https://sincere-skink.10web.cloud/wp-content/uploads/2026/01/New-Mavericks-Raamon-Logo-copy.png" alt="NewMavericks" className="h-11" />
          </Link>

          <MenuProvider menu_id="3" className="flex items-center">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>
      </header>;
}